import { render, staticRenderFns } from "./LeagueRankingView.vue?vue&type=template&id=dc4ae6dc&scoped=true"
import script from "./LeagueRankingView.vue?vue&type=script&lang=js"
export * from "./LeagueRankingView.vue?vue&type=script&lang=js"
import style0 from "./LeagueRankingView.vue?vue&type=style&index=0&id=dc4ae6dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4ae6dc",
  null
  
)

export default component.exports